export default __webpack_public_path__ + "static/media/B0.f8b52779.mp3";